/* unplugin-vue-components disabled */import script from "./WeekdayOpeningHours.vue?vue&type=script&setup=true&lang=js"
export * from "./WeekdayOpeningHours.vue?vue&type=script&setup=true&lang=js"

import "./WeekdayOpeningHours.vue?vue&type=style&index=0&id=4f465a2c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f465a2c"]])

export default __exports__